const isNumeric = (value: unknown): boolean => typeof value === 'string' || typeof value === 'number'
  ? !isNaN(parseFloat(value.toString())) && isFinite(Number(value))
  : false;

export default isNumeric;